// Account Actions
export const DELETE_USER_ACCOUNT = 'USER/DELETE_USER_ACCOUNT'

// Account Connection
export const GET_USER_ACCOUNTS_CONNECTED = 'USER/GET_USER_ACCOUNTS_CONNECTED'

export const ACCOUNTS_CONNECTED_FETCH_START = 'USER/ACCOUNTS_CONNECTED_FETCH_START'
export const ACCOUNTS_CONNECTED_FETCH_FAIL = 'USER/ACCOUNTS_CONNECTED_FETCH_FAIL'
export const ACCOUNTS_CONNECTED_FETCH_END = 'USER/ACCOUNTS_CONNECTED_FETCH_END'

export const SET_ACCOUNTS_CONNECTED = 'USER/SET_ACCOUNTS_CONNECTED'

export const DELETE_ACCOUNT_FETCH_START = 'USER/DELETE_ACCOUNT_FETCH_START'
export const DELETE_ACCOUNT_FETCH_FAIL = 'USER/DELETE_ACCOUNT_FETCH_FAIL'
export const DELETE_ACCOUNT_FETCH_END = 'USER/DELETE_ACCOUNT_FETCH_END'
